
// components/Share.js
import React from 'react';
import { Typography } from '@mui/material';

const Share = () => <Typography variant="h4" align="center" mt={4}>Share</Typography>;

export default Share;